import React from "react";
import Grid from "@material-ui/core/Grid";
import { useHistory } from "react-router-dom";
import Paper from "@material-ui/core/Paper";
import { Box, TextField, Typography } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import clsx from "clsx";
import Button from "@material-ui/core/Button";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ShipCss from "../Ships/ShipsCss.css";
import { useDispatch } from 'react-redux';
import { LOADING } from '../../action';
import { getRequest, postRequest } from "../../services/ApiServices";
import { ToastError } from "../../services/ToastMsg";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { getCookie } from "../../services/Cookies";

const useStyles = makeStyles((theme) => ({
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  paddingTop: {
    paddingTop: "3em",
  },
  root: {
    display: "flex",
    padding: "0px",
  },
  input1: {
    height: 50,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  text1: {
    fontSize: "20px",
    fontWeight: "400",
    "& b": {
      fontWeight: "500",
    },
  },

  paper: {
    padding: theme.spacing(2),
    //   textAlign: "center",
    color: theme.palette.text.secondary,
  },

  drawerClose: {
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: "hidden",
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9) + 1,
    },
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    marginTop: "65px",
    height: "100vh",
  },
  listheight: {
    height: "85vh",
    overflow: "auto",
  },
  liselected: {
    background: "#ff4717",
  },
  boxBorder: {
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  btnStyle2: {
    borderRadius: "8px",
    border: "2px solid #ff4717",
    boxShadow: "2px 2px 4px 2px #dadada",
    color: "#ffffff",
    background: "#ff4717 !important",
    textTransform: "capitalize",
    padding: "4px 22px",
    marginRight: "8px"
},
  btnPrimary: {
    background: "#ff4717",
    color: "white",
    textTransform: "capitalize",
  },
  shipDatailsText: {
    color: "rgb(32 32 32)",
  },

  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  overflowHidden: {
    overflow: "hidden",
    height: "20px",
  },
  arrowIcons: {
    fontSize: "46px",
    marginTop: "-12px",
  },
}));

export default function TransformerDetails(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const [shipBox, setShipBox] = React.useState(true);
  const [frequencyRange, setFrequencyRange] = React.useState("");
  const [newValue, setNewValue] = React.useState();
  const { seletedShip, getShip } = props;
  const [sampleFrequency, setSampleFrequency] = React.useState("");
  const [checkBox, setCheck] = React.useState({ disabled: true, checked: false });
  React.useEffect(() => {

    setSampleFrequency(seletedShip?.transformerSamplingFrequency);
    if (seletedShip?.transformerSamplingFrequency == 0) {
      setCheck({ ...checkBox, ...{ checked: true } })
      setFrequencyRange("0")
    } else if (seletedShip?.transformerSamplingFrequency !== 0) {
      setCheck({ ...checkBox, ...{ checked: false } })
      setFrequencyRange("");
    }
  }, [seletedShip])

  const oninputChange = (value, field) => {
    //
    setFrequencyRange(value)
    // console.log(frequencyRange);
  }
  const onChecked = (value) => {
    //
    if (value == true) {
      setCheck({ ...checkBox, ...{ checked: value } })
      setFrequencyRange("0")
    } else if (value == false) {
      setCheck({ ...checkBox, ...{ checked: value } })
      setFrequencyRange("");
    }

  }
  const handleSubmit = (val) => {
    //
    // if(checkBox.checked==true){
    //   setFrequencyRange("0")
    // }
    //
    if (frequencyRange != "") {
      dispatch({ type: LOADING, payload: true });
      const url = process.env.REACT_APP_CUSTOMER_PORTAL_API_URL + `Transformer/updateTransformerFrequency/${seletedShip.transformerKey}/${frequencyRange}`;
      postRequest(url)
        .then((res) => {
          if (res.data.length) {

            getShip(frequencyRange);
            setSampleFrequency(frequencyRange);
            ToastError("Updated successfully");
            if (checkBox.checked == true) {
              setFrequencyRange("0")
            } else {
              setFrequencyRange("");
            }


          } else {
            ToastError("Updated Unsuccessfully");
          }
          dispatch({ type: LOADING, payload: false });
        })
        .catch((error) => {
          dispatch({ type: LOADING, payload: false });
          ToastError(error.response.data.message);
        });
    } else {
      ToastError("Fill the new sampling Frequency");
    }


  }
  return (
    <div>
      <Box component="div" bgcolor="#fff" boxShadow={1} borderRadius={6}>
        <Box
          component="div"
          bgcolor="#1A1A31"
          py={1.0}
          px={3}
          fontWeight={600}
          fontSize={15}
          color="#fff"
          className={classes.boxBorder}
        >
          <Box display="flex" className={classes.justifyContentBetween}>
            <Box component="span" fontSize="18px">
              Transformers Details
            </Box>
            <Box
              component="span"
              width="0.03"
              className={classes.overflowHidden}
            >
              <Box display={shipBox ? "inline" : "none"} component="span">
                <ArrowDropDownIcon
                  className={classes.arrowIcons}
                  onClick={() => {
                    setShipBox(!shipBox);
                  }}
                />
              </Box>

              <Box display={!shipBox ? "inline" : "none"} component="span">
                <ArrowDropUpIcon
                  className={classes.arrowIcons}
                  onClick={() => {
                    setShipBox(!shipBox);
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Box component="div" px={3} display={shipBox ? "block" : "none"}>
          <Grid container>
            <Grid item sm={6} md={4} className="detailscopy">
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Serial Number : </b>
                {seletedShip.serialNo}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Unit Description : </b>
                {seletedShip.unit}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>
                  Sub Client/Customer :
                </b>
                {seletedShip.subCustomerName}
              </p>
            </Grid>
            <Grid item sm={6} md={4} className="detailscopy">
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Location : </b>
                {seletedShip.transformerLocation}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Year Built : </b>
                {seletedShip.dwtRange}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Voltage : </b>
                {seletedShip.voltage}
              </p>
            </Grid>
            <Grid item sm={6} md={4} className="detailscopy">
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Manufacturer :</b>
                {seletedShip.operator}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Asset Type :</b>
                {seletedShip.type}
              </p>
              <p className={classes.text1}>
                <b className={classes.shipDatailsText}>Rating :</b>
                {seletedShip.rating}
              </p>
            </Grid>
            <Grid item xs={12} textAlign="center">
              {checkBox.checked == true ? "" :
                <Grid container spacing={3} >
                  <Grid item md="3" className="ustptag">
                    <p className={classes.shipDatailsText}>Old Sampling Frequency :</p>
                  </Grid>
                  <Grid item md="6">
                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      //fullWidth
                      inputProps={{ readOnly: true }}
                      min="0"
                      className={classes.txtInput}
                      placeholder="Sampling Days"
                      type={"number"}

                      //value={newValue}
                      value={sampleFrequency}
                    //onChange={(e) => oninputChange(e.target.value, "Frequencyrange")}
                    />


                  </Grid>
                </Grid>
              }

              {checkBox.checked == true ? "" :
                <Grid container spacing={3} >
                  <Grid item md="3" className="ustptag">
                    <p className={classes.shipDatailsText}>New Sampling Frequency :</p>
                  </Grid>
                  <Grid item md="6">
                    <TextField
                      variant="outlined"
                      margin="dense"
                      required
                      className={classes.txtInput}
                      placeholder="Sampling Days"
                      type={"number"}
                      //onChange={(e) => oninputChange(e.target.value, "Frequencyrange")}
                      value={frequencyRange}
                      onChange={(event) =>
                        oninputChange(event.target.value < 0
                          ? (event.target.value = 0)
                          : event.target.value, "Frequencyrange")
                      }
                    />


                  </Grid>
                </Grid>
              }
              <Grid container spacing={3} >
                {/* <Grid item md="6">
                <p style={{ lineHeight: "60px !important" }}>{""}</p>
              </Grid> */}
                <Grid item md="6">
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="checkedA"

                        //disabled={checkBox.disabled}
                        checked={checkBox.checked}
                        onChange={(e) => onChecked(e.target.checked)}
                      />
                    }
                    label="Ad hoc"
                    color="primary"
                    labelPlacement=" insidelabel"
                    disabled={getCookie("userRole") == "VPS Admin" ? false : true}
                  />

                </Grid>
              </Grid>



              <Box component="div" textAlign="left" py={3}>
              {getCookie("userRole") == "VPS Admin" ? (
                <Button
                  variant="outlined" className={classes.btnStyle2} 
                  onClick={() => { handleSubmit('save') }}
                 
                >
                  Save
                </Button>
              ):(
                 ""
              )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
    </div>
  );
}
